module.exports = "/images/acquire-new-customers.svg?1364fcf4169d34baca77bbe4da5eeee8";